// Single source of truth for the canned feedback text: both the sender (thumbs up/down handlers)
// and the recognizer (skill draft/suggestion derivation) must agree on it, since a feedback
// message is otherwise an ordinary user message with no other marker.
export const THUMB_UP_FEEDBACK_MESSAGE = '👍 That looks good, nice work!';
export const THUMB_DOWN_FEEDBACK_MESSAGE = '👎 That’s not quite right, try again.';

export type MessageFeedbackSentiment = 'thumbs_down' | 'thumbs_up';

const matchesFeedbackMessage = (content: string, feedbackMessage: string): boolean => {
  const trimmedContent = content.trim();
  const isExactFeedbackMessage = trimmedContent === feedbackMessage;
  // Until Agents 2.0 provides structured feedback metadata, injected context must be distinguished by its separator.
  const isFeedbackAfterInjectedContext = trimmedContent.endsWith(`\n\n${feedbackMessage}`);

  return isExactFeedbackMessage || isFeedbackAfterInjectedContext;
};

export const getInvocationFeedbackSentiment = (content: string): MessageFeedbackSentiment | null => {
  if (matchesFeedbackMessage(content, THUMB_UP_FEEDBACK_MESSAGE)) {
    return 'thumbs_up';
  }

  if (matchesFeedbackMessage(content, THUMB_DOWN_FEEDBACK_MESSAGE)) {
    return 'thumbs_down';
  }

  return null;
};

export const isInvocationFeedbackMessage = (content: string): boolean =>
  getInvocationFeedbackSentiment(content) !== null;
